import {
  Box,
  Avatar,
  Typography,
  Divider,
  Tooltip,
  useMediaQuery,
  useTheme,
  Chip
} from '@mui/material'
import { PersonAddAlt1 } from '@mui/icons-material'
import { switchAccount } from '../services/AuthApi';
import MentorBadge from '../components/MentorBadge';
import { useSnackbar } from "../context/SnackbarProvider";
import { setToken } from '../utils/tokenUtils';

const ChocolateAccount = ({ user, refreshUser, navigate, setMobileOpen, handleCloseDesktopmenu }) => {
  const { showSnackbar } = useSnackbar();
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('md'));
  const hasAnotherAccount = user?.have_another_account && Object.keys(user.have_another_account).length > 0;

  console.log("Has another account:", user?.have_another_account);

  const closeMenuByScreen = () => {
    if (isSmallScreen) {
      setMobileOpen(false);
    } else {
      handleCloseDesktopmenu();
    }
  };


  const handleChangeToExisting = () => {
    if (user?.have_another_account.is_blocked) {
      showSnackbar("This account has been blocked by freecomers, please contact support.", "error");
      closeMenuByScreen();
      return;
    }

    console.log("Change to existing account");
    switchAccount()
      .then((response) => {
        console.log("Switched account response:", response);
        const newToken = response.token;
        setToken(newToken);
        localStorage.removeItem("myTabKey");
        refreshUser();
        closeMenuByScreen();
      })
      .catch((error) => {
        console.error("Error switching account:", error);
      });
  };

  const handleCreateAnotherAccount = () => {
    const oppositeAccountType =
      user?.account_type === "individual" ? "organization" : "individual";
    navigate("/sign-up", {
      state: { account_type: oppositeAccountType, action: true },
    });
    localStorage.removeItem("myTabKey");
    closeMenuByScreen();
  };

  const handleClickToProfile = () => {
    navigate(`/profile/${user.username}`);
    closeMenuByScreen();
  };

  return (
    <>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          flexDirection: hasAnotherAccount ? "row" : "column",
          alignItems: hasAnotherAccount ? "center" : "flex-start",
          py: 1,
          px: 2,
          gap: 1,
        }}
      >
        <Tooltip title="View Profile" arrow placement='left'>
          <Box
            display="flex"
            alignItems="center"
            gap={1}
            onClick={handleClickToProfile}
            sx={{ cursor: "pointer" }}
          >
            {user?.is_mentor ? (
              <MentorBadge isSmall>
                <Avatar
                  src={user?.thumbnail_pic}
                  alt={user?.name}
                  sx={{ border: "1px solid", borderColor: "divider" }}
                />
              </MentorBadge>
            ) : (
              <Avatar
                src={user?.thumbnail_pic}
                alt={user?.name}
                sx={{ border: "1px solid", borderColor: "divider" }}
              />
            )}

            <Box maxWidth={150}>
              <Typography variant="body1" fontWeight={600}
                sx={{
                  display: '-webkit-box',
                  WebkitLineClamp: 1,
                  WebkitBoxOrient: 'vertical',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                }}>
                {user?.name}
              </Typography>
              <Typography variant="body2" color="text.secondary"
                sx={{
                  display: '-webkit-box',
                  WebkitLineClamp: 1,
                  WebkitBoxOrient: 'vertical',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                }}
              >
                {user?.describes_me}
              </Typography>
            </Box>
          </Box>
        </Tooltip>

        {hasAnotherAccount ? (
          <Tooltip title={`Switch to ${user?.have_another_account?.account_type}`} arrow placement='top'>
            <Box
              sx={{
                position: "relative",
                width: 50,
                height: 50,
              }}
            >
              {/* Loop background */}
              <Box
                component="img"
                src="/loop.svg"
                alt="loop"
                sx={{
                  height: "100%",
                  rotate: "30deg",
                }}
              />

              {/* Avatar on top */}
              <Avatar
                onClick={handleChangeToExisting}
                src={user?.have_another_account?.thumbnail_pic}
                sx={{
                  cursor: "pointer",
                  position: "absolute",
                  top: "50%",
                  left: "50%",
                  transform: "translate(-50%, -50%)",
                  width: 32,
                  height: 32,
                }}
              />
            </Box>
          </Tooltip>
        ) : (
          <Chip
            onClick={handleCreateAnotherAccount}
            icon={<PersonAddAlt1 fontSize="small" />}
            label={`${user?.account_type === "individual" ? "Create Organization" : "Create Individual"} Account`}
            variant='outlined'
            sx={{
              backgroundColor: theme.palette.action.hover,
              width: '100%',
            }}
          />
        )}
      </Box>
      <Divider variant="middle" />
    </>
  );
};

export default ChocolateAccount;
